import * as zod from 'zod';

export const HapticDeviceState = zod.object({
  kind: zod.literal('HapticDevice'),
  isConnected: zod.boolean(),
  modelName: zod.string().nullable().default(null),
  clientId: zod.string().nullable().default(null),
  connectedAt: zod.string().nullable().default(null),
});

export type HapticDeviceState = zod.infer<typeof HapticDeviceState>;
